import { voiceLogsConstants } from "../constants"

export function getVoiceLogsData(state = {}, action) {
    switch (action.type) {
        case voiceLogsConstants.GET_VOICE_LOG_DATA_REQUEST:
        return { loading: true }
        case voiceLogsConstants.GET_VOICE_LOG_DATA_SUCCESS:
        return { 
            data: action.result
            }
        case voiceLogsConstants.GET_VOICE_LOG_DATA_FAILURE:
        return {}
        default:
        return state
    }
}
